/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_InstructionsInputs */

const en_two_fa_recovery_instructions = /** @type {(inputs: Two_Fa_Recovery_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter one of your unused recovery codes. Each code can only be used once.`)
};

const nl_two_fa_recovery_instructions = /** @type {(inputs: Two_Fa_Recovery_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een van je ongebruikte herstelcodes in. Elke code kan maar één keer worden gebruikt.`)
};

/**
* | output |
* | --- |
* | "Enter one of your unused recovery codes. Each code can only be used once." |
*
* @param {Two_Fa_Recovery_InstructionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_instructions = /** @type {((inputs?: Two_Fa_Recovery_InstructionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_InstructionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_instructions(inputs)
	return en_two_fa_recovery_instructions(inputs)
});